import React, { useState, useContext } from 'react';
import { generateId } from '../../../utils/generateId'
import { HiOutlinePlus } from "react-icons/hi2";
import InstagramComents from './InstagramComents';
import FacebookComments from './FacebookComments';
import { Button, Dropdown } from 'components/ui'
import { TbMessage } from 'react-icons/tb';
import { BsStars } from 'react-icons/bs';
import { AIContext } from 'contexts/AIContext';
import { COMMENT_PROMPTS } from 'configs/prompts/comments';
import capitalize from 'components/ui/utils/capitalize';

const CommentsSection = ({post, network, integration, company}) => {
    const {
        postIndex,
        user_name,
        user_image,
        isEditable,
        onCommentsToCreateEdit,
    } = post;
    
    const [comments, setComments] = useState(post.comments_to_create?.map(comment => ({ id: generateId(), text: comment, saved: true })) || []);
    const [isGeneratingAI, setIsGeneratingAI] = useState(false);
    const { getByQueryChat } = useContext(AIContext);

    const handleAddComment = () => {
        const newComment = { id: generateId(), text: "", saved: false };
        setComments([...comments, newComment]);
    };

    const handleUpdateComment = (id, text) => {
        const newComments = comments.map(comment => 
            comment.id === id ? { ...comment, text, saved: true } : comment
        )
        setComments(newComments);
        saveComments(newComments);
    };

    const handleDeleteComment = (id) => {
        const newComments = comments.filter(comment => comment.id !== id);
        setComments(newComments);
        saveComments(newComments);
    };
    
    const saveComments = (newComments) => {
        onCommentsToCreateEdit(postIndex, newComments.filter(c => c.saved).map(comment => comment.text))
    }

    const generateAIComment = async () => {
        setIsGeneratingAI(true);
        const prompt = COMMENT_PROMPTS[Math.floor(Math.random() * COMMENT_PROMPTS.length)];
        const query = `
            ${capitalize(network)} post content: 
            ${post?.text || post?.description}
            
            ${post?.comments_to_create?.length > 0 ? `
                ${capitalize(network)} post previous comments: 
                ${post?.comments_to_create?.map(comment => comment).join('\n')}
            ` : ``}

            ${prompt}
            
            No preambles. Just write the comment.
        `;
        try {
            const aiComment = await getByQueryChat(query);
            const newComment = { id: generateId(), text: aiComment, saved: true };
            setComments([...comments, newComment]);
            saveComments([...comments, newComment]);
        } catch (error) {
            console.error("Error generating AI comment:", error);
        }
        setIsGeneratingAI(false);
    };

    return (
        <div className='mt-2'>
            {comments.map((comment) => {
            const CommentComponent = network === "instagram" ? InstagramComents : FacebookComments;

            return (
                <CommentComponent
                    key={comment.id}
                    comment={comment}
                    user_image={user_image}
                    integration={integration}
                    company={company}
                    network={network}
                    user_name={user_name}
                    updateComment={(text) => handleUpdateComment(comment.id, text)}
                    deleteComment={() => handleDeleteComment(comment.id)}
                    isEditable={isEditable}
                />
            );
        })}
            {isEditable && comments.length < parseInt(process.env.REACT_APP_MAX_COMMENTS_PER_POST) && (
                <div className="flex justify-center items-center gap-2 w-full py-2 px-4">
                    <Dropdown
                        parentClassName="w-full"
                        className="w-full"
                        placement="top-end"
                        renderTitle={
                            <Button 
                                variant="twoTone" 
                                icon={<TbMessage />}
                                className="w-full"
                                loading={isGeneratingAI}
                            > 
                                Add {comments.length === 0 ? "first" : "another"} comment
                            </Button>
                        }
                    >
                        <Dropdown.Item onClick={handleAddComment} className="flex items-center gap-2 py-2 px-4">
                            <HiOutlinePlus className="text-lg" />
                            <span>Generate from scratch</span>
                        </Dropdown.Item>
                        <Dropdown.Item onClick={generateAIComment} className="flex items-center gap-2 py-2 px-4">
                            <BsStars className="text-lg text-fuchsia-500" />
                            <span>Generate with AI</span>
                        </Dropdown.Item>
                    </Dropdown>
                </div>
            )}
        </div>
    )
}

export default CommentsSection;
